<template>
  <div class="text-center">
    <v-overlay :value="loading">
      <v-progress-circular
        :size="70"
        indeterminate
        color="grey lighten-5"
      />
    </v-overlay>
  </div>
</template>

<script>
  export default {
    computed: {
      loading () {
        return this.$store.state.loading
      },
    },
  }
</script>
